import * as React from "react";
import type { SVGProps } from "react";
const SvgMail04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 10.4H2.4V20A1.6 1.6 0 0 0 4 21.6h16a1.6 1.6 0 0 0 1.6-1.6v-9.6H20m-16 0 8 4.8 8-4.8m-16 0V5.6a3.2 3.2 0 0 1 3.2-3.2h9.6A3.2 3.2 0 0 1 20 5.6v4.8"
    />
  </svg>
);
export default SvgMail04;
